export default __webpack_public_path__ + "static/media/DANAMMA.212e2d18.JPG";